var _path, _circle, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvaSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10758 17.418C8.09668 16.8488 9.28899 16.5498 10.5005 16.5498C11.7121 16.5498 12.9044 16.8488 13.8935 17.418C14.8822 17.987 15.6383 18.8111 15.9894 19.7937L14.671 20.2647C14.4523 19.6526 13.9529 19.0675 13.1952 18.6314C12.4379 18.1956 11.4903 17.9498 10.5005 17.9498C9.51076 17.9498 8.56323 18.1956 7.80589 18.6314C7.04814 19.0675 6.54881 19.6526 6.33011 20.2647L5.01172 19.7937C5.36277 18.8111 6.11888 17.987 7.10758 17.418Z",
    fill: "#FC7B52"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 12.25,
    r: 2.5,
    stroke: "#FC7B52",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 6.8,
    width: 13.4,
    height: 13.4,
    rx: 3.2,
    stroke: "#FC7B52",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1586 14.3468C19.1821 14.3207 19.205 14.294 19.2274 14.2668C19.4192 14.0331 19.5734 13.6887 19.6606 12.9512C19.751 12.1862 19.753 11.1749 19.753 9.68023C19.753 8.18561 19.751 7.17428 19.6606 6.40926C19.5734 5.67177 19.4192 5.32737 19.2274 5.09365C19.1311 4.9764 19.0236 4.86888 18.9063 4.77264C18.6726 4.58083 18.3282 4.42662 17.5907 4.33945C16.8257 4.24902 15.8144 4.24698 14.3198 4.24698C12.8251 4.24698 11.8138 4.24902 11.0488 4.33945C10.3113 4.42662 9.96691 4.58083 9.73319 4.77264C9.70598 4.79497 9.6793 4.8179 9.65317 4.84142C9.48886 4.98929 9.28404 5.09365 9.06299 5.09365H8.91349C8.47107 5.09365 8.16758 4.64458 8.44825 4.30258C8.5963 4.12218 8.76171 3.95677 8.94211 3.80872C9.92754 3 11.3916 3 14.3198 3C17.2479 3 18.712 3 19.6974 3.80872C19.8778 3.95677 20.0432 4.12218 20.1913 4.30258C21 5.288 21 6.75208 21 9.68022V9.68023V9.68024C21 12.6084 21 14.0725 20.1913 15.0579C20.0432 15.2383 19.8778 15.4037 19.6974 15.5518C19.3554 15.8324 18.9063 15.5289 18.9063 15.0865V14.937C18.9063 14.716 19.0107 14.5111 19.1586 14.3468Z",
    fill: "#FC7B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaSquare);
export default __webpack_public_path__ + "static/media/ava-square.72b2e57a8df7bd09977831cd645c8c09.svg";
export { ForwardRef as ReactComponent };